import './instrument'; // Sentry must be first import

// Clear chunk reload flag on successful page load
sessionStorage.removeItem('chunk_reload');

import { createRoot } from 'react-dom/client';
import { reactErrorHandler } from '@sentry/react';
import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.jsx';
import { AuthProvider } from './contexts/AuthContext';
import { ChatflowsProvider } from 'chatflows-embed';

createRoot(document.getElementById('root'), {
  onUncaughtError: reactErrorHandler(),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
}).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ChatflowsProvider>
          <App />
        </ChatflowsProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
